import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const FAQS = [
  {
    q: "What is Crew Coin?",
    a: "Crew Coin is an employee incentive app for shift based teams that gives managers a way to provide instant gratification to their employees.",
  },
  {
    q: "How do employees earn coins?",
    a: "Managers set goals or create challenges for staff to earn coins.",
  },

  {
    q: "What rewards can we offer?",
    a: "Anything you want. You fill the store - Gift cards, shift perks, PTO-style perks, meals, and team prizes.",
  },
  {
    q: "Who provides the rewards?",
    a: "When employees redeem coins for rewards, admins are responsible for reward delivery.",
  },
  
];

export default function FAQWidget({ hideFloating = false, buttonClassName = "", buttonStyle = {} }) {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [showFab, setShowFab] = useState(true);
  const [query, setQuery] = useState("");
  const lastScrollY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || 0;
      const scrollingUp = y < lastScrollY.current;
      lastScrollY.current = y;

      const doc = document.documentElement;
      const atBottom = y + window.innerHeight >= doc.scrollHeight - 8;

      const contactEl = document.getElementById("contact");
      const inContactArea = contactEl
        ? contactEl.getBoundingClientRect().top < window.innerHeight - 80
        : false;

      if (atBottom || inContactArea) {
        setShowFab(false);
      } else if (scrollingUp || !inContactArea) {
        setShowFab(true);
      }
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const filtered = useMemo(() => {
    if (!query.trim()) return FAQS;
    const q = query.toLowerCase();
    return FAQS.filter((f) => f.q.toLowerCase().includes(q) || f.a.toLowerCase().includes(q));
  }, [query]);

  const path = String(location?.pathname || "").toLowerCase();
  const isDashboardPath = path.includes("dashboard") || path.includes("/user");

  return (
    <>
      {hideFloating ? (
        <button
          className={buttonClassName}
          style={buttonStyle}
          onClick={() => setOpen(true)}
          aria-label="Open FAQ help"
        >
          Need Help?
        </button>
      ) : (
        <button
          className={`cc-faq-fab ${showFab && !isDashboardPath ? "" : "cc-faq-fab-hidden"}`}
          onClick={() => setOpen(true)}
          aria-label="Open FAQ help"
          aria-hidden={!showFab || isDashboardPath}
          tabIndex={showFab && !isDashboardPath ? 0 : -1}
        >
          Need Help?
        </button>
      )}

      {open && (
        <div className="cc-faq-modal-backdrop" onClick={() => setOpen(false)}>
          <div className="cc-faq-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <div className="cc-faq-modal-header">
              <h4>Quick FAQs</h4>
              <button className="cc-faq-close" onClick={() => setOpen(false)} aria-label="Close FAQ">
                ×
              </button>
            </div>

            <div className="cc-faq-scroll">
              {filtered.map((item) => (
                <details key={item.q} className="cc-faq-item">
                  <summary>{item.q}</summary>
                  <p>{item.a}</p>
                </details>
              ))}
              {!filtered.length && <p className="cc-faq-empty">No matching FAQs yet.</p>}
            </div>

            <div className="cc-faq-footer">
              <div className="cc-faq-footer-links">
                <Link to="/faq" className="cc-faq-action-link" onClick={() => setOpen(false)}>
                  <span className="cc-faq-link-icon"><i className="fa fa-clipboard" aria-hidden="true"></i></span> View full FAQ
                </Link>
                <a className="cc-faq-action-link" href="mailto:admin@crew-coin.com?subject=Crew%20Coin%20Help%20Request">
                  <span className="cc-faq-link-icon">✉</span> Email support
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
